<script setup lang="ts">
import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

type ItemMenuSize = 'sm' | 'md';

const { size = 'md', active = false, isArrow = true, textColor = 'text-brown-600' } = defineProps<{
  label: string;
  icon?: string;
  routerTo?: RouteLocationRaw;
  href?: string;
  size?: ItemMenuSize;
  active?: boolean;
  isArrow?: boolean;
  textColor?: string;
}>();

const SIZE_CLASSES: Record<string, { card: string; icon: string; }> = {
  md: { card: 'text-sm px-4 py-2.5', icon: 'text-2xl' },
  sm: { card: 'text-xs px-4 py-1', icon: 'text-base' }
};

const getSizeSet = (size: ItemMenuSize) => { return SIZE_CLASSES[size]; }

const itemSize = computed(() => getSizeSet(size));
</script>

<template>
  <component
    :is="href ? 'a' : 'RouterLink'"
    v-bind="href ? { href, target: '_blank', rel: 'noopener' } : { to: routerTo }"
    class="rounded-sm flex flex-row gap-2 font-roboto-slab items-center transition"
    :class="[
      itemSize.card,
      textColor,
      active ? 'bg-yellow-100' : 'bg-white hover:bg-yellow-100'
    ]"
  >
    <slot name="icon">
      <i
        v-if="icon"
        :class="[itemSize.icon, icon]"
      />
    </slot>
    <div class="flex flex-col">
      <strong>{{ label }}</strong>
    </div>
    <i
      v-if="isArrow"
      class="mi-chevron-r ml-auto text-base"
    />
  </component>
</template>
